import "./ClientMedicalSupplementsFormComponent.scss";
import {IClientMedicalSupplementsForm} from "../../../../shared/models/client.model";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {Misc} from "../../../../constants";
import CardComponent from "../../../../shared/components/card/CardComponent";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import FormikTextAreaComponent
    from "../../../../shared/components/form-controls/formik-text-area/FormikTextAreaComponent";
import {useDispatch} from "react-redux";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";
import HeadingWithNavigationComponent
    from "../../../../shared/components/heading-with-navigation/HeadingWithNavigationComponent";
import DetailsViewCardComponent from "../../../../shared/components/details-view-card/DetailsViewCardComponent";
import AcknowledgementFormComponent from "../../acknowledgement-form/AcknowledmentFormComponent";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";

interface ClientMedicalSupplementsFormComponentProps {
    onCancel: () => void;
    onNext?: () => void;
    clientId: string;
    onSave: (clientMedicalSupplementsDetails: any) => void;
    clientMedicalHistoryDetails: any;
    isClientMedicalHistoryDetailsLoaded: boolean | undefined;
    isClientMedicalHistoryDetailsLoading: boolean | undefined;
    isClientMedicalHistoryDetailsLoadingFailed: boolean | undefined;
}


// const ClientMedicalSupplementsValidationSchema = Yup.object({
//     medications: Yup.object({
//         prescription_medication: Yup.string().required('Prescription Medication is required'),
//         non_prescription_medication: Yup.string().required('Non Prescription Medication is required'),
//     }),
// });

const ClientMedicalSupplementsInitialValues: IClientMedicalSupplementsForm = {
    medications: {
        prescription_medication: "",
        non_prescription_medication: "",
    }
};

const ClientMedicalSupplementsFormComponent = (props: ClientMedicalSupplementsFormComponentProps) => {

    const {
        onCancel, onSave, clientMedicalHistoryDetails,
        clientId,
        isClientMedicalHistoryDetailsLoaded,
        isClientMedicalHistoryDetailsLoading,
        isClientMedicalHistoryDetailsLoadingFailed
    } = props;
    const [clientMedicalSupplementsInitialValues, setClientMedicalSupplementsInitialValues] = useState<IClientMedicalSupplementsForm>(_.cloneDeep(ClientMedicalSupplementsInitialValues));
    const [isClientMedicalSupplementsSavingInProgress, setIsClientMedicalSupplementsSavingInProgress] = useState(false);
    const [isAcknowledgementModalOpen, setIsAcknowledgementModalOpen] = useState(false);

    const dispatch = useDispatch();

    const onSubmit = useCallback((values: any, {setErrors}: FormikHelpers<any>) => {
        setClientMedicalSupplementsInitialValues(values);
        setIsAcknowledgementModalOpen(true);
    }, [])

    const handleAcknowledgementFormSubmit = useCallback((acknowledgementValues: any) => {
        const payload = {
            ...clientMedicalSupplementsInitialValues,
            ...acknowledgementValues,
            client_id: clientId,
        };
        setIsClientMedicalSupplementsSavingInProgress(true);
        CommonService._client.ClientMedicalHistoryQuestionnaireMedicationSupplementsDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<IClientMedicalSupplementsForm>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setIsClientMedicalSupplementsSavingInProgress(false);
                setClientMedicalSupplementsInitialValues(_.cloneDeep(clientMedicalSupplementsInitialValues));
                onSave(response);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error[Misc.API_RESPONSE_MESSAGE_KEY], 'error');
                setIsClientMedicalSupplementsSavingInProgress(false);
            })
    }, [onSave,clientId,clientMedicalSupplementsInitialValues]);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientMedicalSupplementsInitialValues({
                medications: clientMedicalHistoryDetails.medications
            });
        }
    }, [dispatch, clientMedicalHistoryDetails]);

    return (
        <div className={'client-medical-supplements-form-component'}>
            {
                isClientMedicalHistoryDetailsLoading && <div>
                    <LoaderComponent/>
                </div>
            }
            {
                isClientMedicalHistoryDetailsLoadingFailed &&
                <StatusCardComponent title={"Failed to fetch medical Details"}/>
            }
            {isClientMedicalHistoryDetailsLoaded && <>
                <HeadingWithNavigationComponent onBackNavigation={onCancel}
                                                title={"Back"}/>
                <Formik
                    // validationSchema={ClientMedicalSupplementsValidationSchema}
                    initialValues={clientMedicalSupplementsInitialValues}
                    onSubmit={onSubmit}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}>
                    {({values, isValid, validateForm}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);
                        return (<CardComponent>
                                <div className={'edit-medication-heading'}>
                                    Edit Medications/Supplements
                                </div>
                                <Form noValidate={true} className={"t-form"}>
                                    <div className={'medication-wrapper'}>
                                        <DetailsViewCardComponent title={"Medications/Supplements"}>
                                            <div className="ts-row">
                                                <div className="ts-col">
                                                    <Field name={`medications.prescription_medication`}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikTextAreaComponent
                                                                    id={"prescription_input"}
                                                                    label={"Please list all prescription medications you are currently taking:"}
                                                                    placeholder={"Please list all non-prescription medications you are currently taking:"}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                    rows={3}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <Field name={`medications.non_prescription_medication`}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikTextAreaComponent
                                                                    id={"non_prescription_input"}
                                                                    label={"Please list all non-prescription medications you are currently taking:"}
                                                                    placeholder={"Please list all non-prescription medications you are currently taking:"}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                    rows={3}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                </div>
                                                <div className={"ts-col-1"}/>
                                            </div>
                                        </DetailsViewCardComponent>
                                    </div>
                                    <div className="t-form-actions mrg-bottom-0">
                                        <ButtonComponent
                                            id={"home_btn"}
                                            variant={"outlined"}
                                            onClick={onCancel}
                                            disabled={isClientMedicalSupplementsSavingInProgress}
                                            color={"accent"}
                                        >
                                            Cancel
                                        </ButtonComponent>&nbsp;
                                        <ButtonComponent
                                            id={"save_next_btn"}
                                            className={'mrg-left-25'}
                                            isLoading={isClientMedicalSupplementsSavingInProgress}
                                            disabled={isClientMedicalSupplementsSavingInProgress || !isValid}
                                            type={"submit"}
                                            color={"accent"}
                                        >
                                            Next
                                        </ButtonComponent>
                                    </div>
                                </Form>
                            </CardComponent>
                        )
                    }}
                </Formik>
            </>}
            <ModalComponent isOpen={isAcknowledgementModalOpen}>
                <AcknowledgementFormComponent setIsAcknowledgementModalOpen={setIsAcknowledgementModalOpen}
                                              isLoading={isClientMedicalSupplementsSavingInProgress}
                                              onSubmit={handleAcknowledgementFormSubmit}/>
            </ModalComponent>
        </div>
    );

};

export default ClientMedicalSupplementsFormComponent;
